import { Injectable } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';

@Injectable({
  providedIn: 'root'
})
export class UtilService {

  constructor(private spinner: NgxSpinnerService) 
  {   
  }

  public showLoading(display: boolean = true) {
    if (display) {
      this.spinner.show();
    } else {
      this.spinner.hide();
    }
  }

/*   public guardaObjestoSessao(key:string, objeto:any){
    localStorage.setItem(key, JSON.stringify(objeto));
  }

  public recuperaObjetoSessao(key:string): any {
    return  JSON.parse(localStorage.getItem(key));
  }

  public removeItemSessao(key:string) {
    localStorage.removeItem(key);
  } */

}